<template>
    <v-layout row wrap>
        <v-layout row wrap justify-start>
            <v-btn id="return" v-if="canReturn" rounded @click="emit('return')" style="background-color:#e8e8e8;">
                <span class="marginSpan"> Voltar </span>
                <v-icon small>fa-arrow-left</v-icon>
            </v-btn>
            <v-btn id="deleteRegistro" v-if="canDelete" dark rounded color="#FF5252" @click="emit('delete')" style="margin-left: 5px;">
                <span class="marginSpan"> Deletar </span>
                <v-icon small>fa-trash-alt</v-icon>
            </v-btn>
        </v-layout>
        <v-layout row wrap justify-end>
            <v-btn id="saveRegistro" v-if="canSave" rounded color="primary" @click="emit('save')">
                <span class="marginSpan"> Salvar </span>
                <v-icon small>fa-save</v-icon>
            </v-btn>
        </v-layout>
    </v-layout>
</template>

<script>

export default {
    name: 'ActionButtonsForm',
    methods:{
        emit(event) {
            this.$emit(event)
        },
    },
    props:{
        canSave: {
            type: Boolean,
            default: true
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        canReturn: {
            type: Boolean,
            default: true
        },
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .card {
        margin: 10px
    }
    .marginSpan {
        margin: 5px
    }
</style>